











































import Vue from 'vue';
import VeLine from 'v-charts/lib/line.common';
import scheduleClient from '../../apis';
import moment from 'moment';

export default Vue.extend({
  components: {
    VeLine,
  },
  props: {
    width: {
      type: String,
      default: '580px',
    },
    ruleId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      failureData: [],
      loadedFailureData: false,
      loadedProbabilityData: false,
      probabilityData: false,
      start: moment().subtract(20, 'days').format('YYYY-MM-DD hh:mm:ss'),
      end: moment().format('YYYY-MM-DD hh:mm:ss'),
      options2: {},
      legend: {
        show: false,
      },
      chartSettingsF: {
        stack: { 'date': ['count']},
        area: true,
        labelMap: {
          count: '失败数',
        },
        lineStyle: {
          color: '#BD10E0',
        },
      },
      chartSettingsS: {
        stack: { 'date': ['count']},
        labelMap: {
          count: '成功率',
        },
        area: true,
        lineStyle: {
          color: '#00B177',
        },
      },
      chartDataF: {
        columns: ['date', 'count'],
        rows: [],
      },
      chartDataS: {
        columns: ['date', 'count'],
        rows: [],
      },
      tooltip: {
        formatter: '{b} : {d}%',
      },
      chartExtend: {
        series: {
          symbol: 'none',
        },
        xAxis: {
          show: false,
          boundaryGap: false,
        },
        yAxis: {
          show: false,
        },
      },
      grid: [{
        left: 0,
        right: 0,
        width: '100%',
      }],
      colorsF: ['#FADFFF'],
      colorsS: ['#A5EAD8'],
      loadingF: true,
      loadingS: true,
    };
  },
  methods: {
    getFailureCount() {
      this.loadedFailureData = false;
      scheduleClient.getFailureCount({
        ruleId: this.ruleId,
        start: this.start, 
        end: this.end}).success((res) => {
        this.chartDataF.rows = res.map((r: any) => this.getRowDataF(r));
        this.loadingF = false;
        this.loadedFailureData = true;
      });
    },
    getRowDataF(item: any) {
      return {date: moment(item.day).format('YYYY-MM-DD'), count: item.count};
    },
    getRowDataS(item: any) {
      return {date: moment(item.day).format('YYYY-MM-DD'), count: item.Probability === 0 ?  0 : (item.Probability ? item.Probability : 1)};
    },
    getProbabilityData() {
      scheduleClient.getProbabilityData({
        ruleId: this.ruleId,
        start: this.start, 
        end: this.end}).success((res) => {
        this.chartDataS.rows = res.map((r: any) => this.getRowDataS(r));
        this.loadingS = false;
        this.loadedProbabilityData = true;
      });
    },
  },
  mounted() {
    this.getFailureCount();
    this.getProbabilityData();
  },
});
